import 'boot/webpackPublicPath';
import 'boot/vendor';
import 'vendorized-fonts/font-awesome-v6-kit-f11102cc8a/font-awesome-v6-fonts.global.scss';
import 'boot/common/setMomentLocale';
import 'boot/common/exportReact';

import './globalSetup';

import './exposeComponents';

import { mountAllComponents } from 'boot/common/reactMount';
$(document).ready(mountAllComponents);

import './hookActionSpecificSetup';

import i18nSetup from 'boot/common/i18nSetup';
i18nSetup();
